import React, { cloneElement, useRef, useCallback, ReactElement } from "react";

import { OnSelectedItemChange, RenderItems } from "./dropdown.helpers";
import { Dropdown, DropdownProps } from "./Dropdown";
import { DropdownItemInterface } from "./DropdownItem";

function isReactElement(
  item: DropdownItemInterface | ReactElement
): item is ReactElement {
  return (item as DropdownItemInterface).content === undefined;
}

export const LazyLoadDropdown = (props: DropdownProps) => {
  const actionCallbackRef = useRef<() => void>(null);

  const handleSelectedItemChange = useCallback<OnSelectedItemChange>(() => {
    const selectedAction = actionCallbackRef.current;

    selectedAction && selectedAction();
  }, []);

  const renderItems = useCallback<RenderItems<ReactElement>>(
    ({ items, highlightedIndex, getItemProps }) => {
      return items.map((item, index) => {
        if (!isReactElement(item)) {
          throw new Error("Item should be a ReactElement");
        }

        return cloneElement(item, {
          item,
          key: index,
          index,
          highlighted: highlightedIndex === index,
          onHighlightedChange: (itemActionCallback: () => void) => {
            actionCallbackRef.current = itemActionCallback;
          },
          getItemProps,
        });
      });
    },
    []
  );

  return (
    <Dropdown
      {...props}
      renderItems={renderItems}
      onSelectedItemChange={handleSelectedItemChange}
    />
  );
};
